<div class="ms-auto">
  Powered by
  <a href="mailto:lawrence@wbsolution.co" target="_blank">
    <span> Webble IT Solution</span>
  </a>
</div>
